import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    breadCrumbContainer: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        ...theme.mixins.flex.alignItemsCenter,
    },
    linkContainer: {
        '& a': {
            fontWeight: 'normal',
            color: theme.palette.text.primary,
        },
    },
    truncatedCrumb: {
        maxWidth: 350,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline-block',
        verticalAlign: 'middle',
    },
    breadCrumbSeparator: {
        margin: '0px 6px 0px 6px',
        '& svg': {
            position: 'relative',
            top: 'calc(50% - 11px)',
            fontSize: '10px',
        },
    },
    jumpToReportingContainer: {
        marginLeft: theme.spacing(1),
        '& a': {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.alignItemsCenter,
            height: '100%',
        },

        '& svg': {
            fontSize: '16px',
        },

        // Some buttons will be rendered as an <a> tag, do not
        // mess with those...
        '& a:not(.MuiButton-root)': {
            color: theme.palette.grey[600],

            '&:hover': {
                color: theme.palette.grey[500],
                textDecoration: 'none',
            },
        },
    },
}));

export default useStyles;
